import { render, staticRenderFns } from "./PageLikes.vue?vue&type=template&id=273752ae&"
import script from "./PageLikes.vue?vue&type=script&lang=js&"
export * from "./PageLikes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports